import Skeleton from "react-loading-skeleton";

const QuickMenuSkeleton = () => {
  return (
    <div className="grid grid-cols-3 grid-rows-2 gap-1">
      {[...Array(6)].map((_, index) => (
        <Skeleton
          key={index}
          width="100%"
          height="100%"
          borderRadius="0"
          enableAnimation={true}
          style={{
            paddingTop: "100%",
            fontSize: 0,
          }}
        />
      ))}
    </div>
  );
};

export default QuickMenuSkeleton;
